import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FluiditeTauxOccupationValues } from '@timechef/core/api';
import { Observable } from 'rxjs';
import { buildFluiditeDsKey, RestaurantsRepository } from '../../../state';
import { Restaurant } from '../../../state/restaurants.models';

@Component({
  selector: 'app-restaurant-fluidite',
  templateUrl: './restaurant-fluidite.component.html',
  styleUrls: ['./restaurant-fluidite.component.scss'],
  standalone: false,
})
export class RestaurantFluiditeComponent implements OnInit {
  FluiditeTauxOccupationValues = FluiditeTauxOccupationValues;

  @Input() restaurantId?: number;

  restaurants: (Restaurant & { fluiditeDetailsDS$: Observable<any> })[] = [];
  sliderOptions = { initialSlide: 0 };

  constructor(
    private restaurantsRepo: RestaurantsRepository,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit(): void {
    this.restaurants = this.restaurantsRepo.getRestaurantsWithFluidite().map((r) => {
      return { ...r, fluiditeDetailsDS$: this.restaurantsRepo.restaurantFluiditeDetailsDS.data$({ key: buildFluiditeDsKey(r.id) }) };
    });

    if (this.restaurantId) {
      this.sliderOptions = { ...this.sliderOptions, initialSlide: this.restaurants.findIndex((r) => r.id === this.restaurantId) };
    }
  }

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
